import styled from 'styled-components'

export const IdeaContainerBox = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
